import Tab from './Tab';
import { TabProps, TabValueProps } from './types';

export type { TabProps, TabValueProps };
export default Tab;
